/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { selectors as groupSelectors } from '../../../../redux/ducks/group';
import * as selectors from '../../../redux/reduxSelectors';

import Spacer from '../../../../components/Spacer';
import { Heading, Caption } from '../../../../components/Text';
import GroupMetadataModel from '../../../../../models/GroupMetadata';
import { GroupThemeMarkdown } from '../../../../components/Markdown';
import I18nText from '../../../../components/I18nTranslation';

function mapStateToProps(state) {
  return {
    getGroup: (groupId) => (new GroupMetadataModel(groupSelectors.getGroup(state, groupId))),
    preferredLanguage: selectors.getCurrentLocaleLanguageCode(state),
  };
}

const GroupEligibilityText = (props) => {
  const group = props.getGroup(props.groupId);

  return (
    <div>
      <Heading>
        <FormattedMessage id="groupJoinEligibility.eligibility.heading.text" />
      </Heading>

      <Spacer size="10" />

      {
        group.eligibility.hasValue() ? (
          <I18nText data={group.eligibility.get()}>
            {
              (txt) => <GroupThemeMarkdown text={txt} />
            }
          </I18nText>
        ) : (
          <Caption>
            <FormattedMessage id="groupJoinEligibility.noCriteria.message.text" />
          </Caption>
        )
      }
    </div>
  );
};
GroupEligibilityText.propTypes = {
  groupId: PropTypes.number,
  getGroup: PropTypes.func,
  preferredLanguage: PropTypes.string,
};

export default connect(mapStateToProps)(GroupEligibilityText);
